import { defineComponent as _defineComponent } from 'vue'
import HLS from 'hls.js';

import { ref, onMounted, onUpdated } from 'vue';

import ReelsExp from '../index';


export default /*#__PURE__*/_defineComponent({
  __name: 'HLSPlayer',
  props: {
    link: null,
    downloadVideo: { type: Boolean, default: true },
    isMuted: { type: Boolean, default: false },
    isLooped: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: false },
    titleId: null,
    fromModal: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as { link: string, downloadVideo: boolean, isMuted: boolean, isLooped: boolean, autoplay: boolean, titleId: string, fromModal?: boolean };



// Use a non-reactive variable for mute state
// This way changing it won't trigger Vue reactivity
let isMuted = props.isMuted;

const video = ref<HTMLVideoElement | null>(null);
const loopedIndex = ref<number>(0);

// Use a function instead of a computed property for the icon
function getVolumeIcon() {
	const filename = isMuted ? 'volume-xmark' : 'volume-high';
	return `/${ASSETS_DIR}/img/sponsored-recommendation-assets/${filename}.svg`;
}

function onVideoStarted() {
	if (!props.fromModal) return;
	if (!props.titleId || props.titleId === '') return;
	ReelsExp.trackEvent({
		action: 'click',
		label: `${props.titleId}_view`,
		property: 'shorts_popular',
	});
}

function onVideoEnded() {
	if (!props.fromModal) return;
	loopedIndex.value += 1;
	if (loopedIndex.value < 2) return;
	ReelsExp.trackEvent({
		action: 'click',
		label: `${props.titleId}_100view_${loopedIndex.value - 1}`,
		property: 'shorts_popular',
	});
}

onMounted(() => {
	prepareVideoPlayer();
});

onUpdated(() => {
	prepareVideoPlayer();
});

function handleSoundToggle() {
	// Toggle mute state manually on the video element
	if (video.value) {
		// Toggle the mute state
		video.value.muted = !video.value.muted;
		// Update our non-reactive variable to keep track
		isMuted = video.value.muted;

		// Force a re-render of just the button by creating a new DOM element
		const container = document.querySelector('.overlay-buttons');
		if (container) {
			const oldImg = container.querySelector('img');
			if (oldImg) {
				// Create new image with updated src
				const newImg = document.createElement('img');
				newImg.src = getVolumeIcon();
				newImg.alt = 'volume';
				newImg.style.fill = 'white';
				// Replace old image with new one
				container.replaceChild(newImg, oldImg);
			}
		}
	}

	if (isMuted) {
		ReelsExp.trackEvent({
			action: 'click',
			label: 'mute',
			property: 'shorts_popular',
		});
	} else {
		ReelsExp.trackEvent({
			action: 'click',
			label: 'unmute',
			property: 'shorts_popular',
		});
	}
}

function prepareVideoPlayer() {
	let hls = new HLS();
	hls.loadSource(props.link);
	if (video.value) {
		hls.attachMedia(video.value);
		// Set initial mute state
		video.value.muted = isMuted;

		if (props.autoplay) play();
	}
}

function pause() {
	if (!video.value) return;
	video.value.pause();
}

function play() {
	if (!video.value) return;
	video.value.play();
}

function reset() {
	if (!video.value) return;
	video.value.currentTime = 0;
}

expose({
	pause,
	play,
	reset,
});

return { __sfc: true,props, isMuted, video, loopedIndex, getVolumeIcon, onVideoStarted, onVideoEnded, handleSoundToggle, prepareVideoPlayer, pause, play, reset }
}

})